/**
 * API attendance datetimes are tenant-local wall times: "YYYY-MM-DD HH:mm:ss".
 * Parse them as local clock components (not UTC ISO strings).
 */
export function parseAttendanceDateTime(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const match = String(value)
    .trim()
    .match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);

  if (match) {
    const [, y, mo, d, h, mi, s] = match;
    return new Date(+y, +mo - 1, +d, +h, +mi, +(s || 0));
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatAttendanceTime(value) {
  const d = parseAttendanceDateTime(value);
  if (!d) return "-";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function formatAttendanceDate(value) {
  if (!value) return "-";
  const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const [, y, mo, d] = match;
    return new Date(+y, +mo - 1, +d).toLocaleDateString([], {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }
  const parsed = parseAttendanceDateTime(value);
  return parsed
    ? parsed.toLocaleDateString([], {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : String(value);
}
